/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../../../../__generated__/zeus/types';

import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
/** The property and displayed mortgage quote selected for pre-approval. */
export type BuyerMortgageApplicationLinkCreateInput = {
  /** Address UUID of the home being financed. */
  addressId: Types.Scalars['UUID']['input'];
  /** A random identifier for this selection; reuse it when retrying the same quote. */
  idempotencyKey: Types.Scalars['UUID']['input'];
  /** Quote identifier from the displayed mortgage offer. */
  quoteId: Types.Scalars['UUID']['input'];
};

/** Loan structures available for the listed home’s mortgage estimate. */
export type MarketplaceMortgageProduct =
  /** Thirty-year loan with a rate fixed for the first five years. */
  | 'FIVE_YEAR_ARM'
  /** Thirty-year loan with a rate fixed for its full term. */
  | 'THIRTY_YEAR_FIXED';

export type CreateListingMortgageApplicationLinkMutationVariables = Exact<{
  input: Types.BuyerMortgageApplicationLinkCreateInput;
}>;


export type CreateListingMortgageApplicationLinkMutation = { buyerMortgageApplicationLinkCreate:
    | { __typename: 'InvalidInputError' }
    | { __typename: 'MortgageApplicationLink', url: Types.Scalars['URL']['output'] }
    | { __typename: 'MortgageQuoteUnavailableError', message: Types.Scalars['String']['output'], canRetryQuote: Types.Scalars['Boolean']['output'], currentOffer: { quoteId: Types.Scalars['UUID']['output'], rateAsOf: Types.Scalars['DateTime']['output'], purchasePriceCents: Types.Scalars['SafeInt']['output'], loanAmountCents: Types.Scalars['SafeInt']['output'], downPaymentPercent: Types.Scalars['Float']['output'], creditScore: Types.Scalars['SafeInt']['output'], lockPeriodDays: Types.Scalars['SafeInt']['output'], products: Array<{ product: Types.MarketplaceMortgageProduct, isPromotionalRate: Types.Scalars['Boolean']['output'], ratePercent: Types.Scalars['Float']['output'], aprPercent: Types.Scalars['Float']['output'], principalAndInterestCents: Types.Scalars['SafeInt']['output'] }> } | null }
    | { __typename: 'NotFoundError' }
    | { __typename: 'UnauthorizedError' }
   };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const CreateListingMortgageApplicationLinkDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreateListingMortgageApplicationLink($input: BuyerMortgageApplicationLinkCreateInput!) {
  buyerMortgageApplicationLinkCreate(input: $input) {
    __typename
    ... on MortgageApplicationLink {
      url
    }
    ... on MortgageQuoteUnavailableError {
      message
      canRetryQuote
      currentOffer {
        ...MarketplaceMortgageOfferFields
      }
    }
  }
}
    fragment MarketplaceMortgageOfferFields on MarketplaceListingMortgageOffer {
  quoteId
  products {
    product
    isPromotionalRate
    ratePercent
    aprPercent
    principalAndInterestCents
  }
  rateAsOf
  purchasePriceCents
  loanAmountCents
  downPaymentPercent
  creditScore
  lockPeriodDays
}`) as unknown as TypedDocumentString<CreateListingMortgageApplicationLinkMutation, CreateListingMortgageApplicationLinkMutationVariables>;